export const state = () => ({
	loading: false,
	lookupDevice: null,
	error: null,
});

export const getters = {
	lookupDevice(state) {
		return state.lookupDevice;
	},
	error(state) {
		return state.error;
	},
};

export const mutations = {
	setLookupDevice(state, device) {
		state.lookupDevice = device;
	},
	setError(state, error) {
		state.error = error;
	},
};

export const actions = {
	async fetchDeviceInfo({dispatch, commit, rootGetters}, meid) {
		dispatch('clearError');

		try {
			const queryParams = getUserQueryParams(rootGetters);
			const request = await this.$axios.$get(`/api/devices/${meid}`, {params: queryParams});
			if (request.success) {
				dispatch('setLookupDevice', {...request.device, brandData: request.brand});
			} else {
				dispatch('setLookupDevice', null);
				commit('setError', request.message);
			}
		} catch (error) {
			dispatch('setLookupDevice', null);
			commit('setError', error.message);
		}
	},
	async setDeviceStatus({dispatch, rootState}, devicePayload) {
		dispatch('clearError');
		try {
			const user = rootState.user.user;
			await this.$axios.$put(`/api/devices/${devicePayload.id}`, {user: user, device: devicePayload});
		} catch (error) {
			console.log('Eror: ', error);
			this.$sentry.captureException(new Error(error.data.message));
			dispatch('setError', error.data.message);
		}
	},
	async refreshLookupDevice({dispatch, getters}) {
		try {
			const lookupDevice = getters['lookupDevice'];
			if (lookupDevice.serials) {
				const { serial } = lookupDevice.serials.find(s => s.type === 'MEID');
				await dispatch('fetchDeviceInfo', serial);
			}
		} catch (error) {
			dispatch('setError', error.message);
		}
	},
	// async sendLookupDeviceMessage({dispatch, rootState, getters}, title, content) {
	// 	const lookupDevice = getters['lookupDevice'];
	// 	if (lookupDevice) {
	// 		const user = rootState.state.user.user;
	// 	}
	// },
	setError({commit}, error) {
		commit('setError', error);
	},
	async clearError({commit}) {
		commit('setError', null);
	},
	clearLookupDevice({commit}) {
		commit('setLookupDevice', null);
	},
	setLookupDevice({commit}, device) {
		commit('setLookupDevice', device);
	},
};


function getUserQueryParams(rootGetters) {
	const queryParams = {};
	const isConversaEmployee = rootGetters['user/isConversaEmployee'];
	if (isConversaEmployee) {
		queryParams['employee'] = isConversaEmployee;
	}

	const guid = rootGetters['user/guid'];
	if (guid) {
		queryParams['customer'] = guid;
	}

	return queryParams;
}

export const strict = false;
